import { createFileRoute } from '@tanstack/react-router';
import { InvitePage } from '@/features/account/InvitePage';

export const Route = createFileRoute('/invite/$token')({
  head: () => ({ meta: [{ title: 'Invitation · Eryce' }, { name: 'robots', content: 'noindex' }, { name: 'referrer', content: 'no-referrer' }] }),
  component: function InviteRoute() {
    const { token } = Route.useParams();
    return <InvitePage token={token} />;
  },
});
